<template>
  <div :class="['body_show',state?'body_shows':'']" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="top">
      <h1>{{data.headtitle}}</h1>
      <h2>测试者：{{data.nickname}}</h2>
      <h3>{{data.ctime}}</h3>
      <a @click="reset" v-if="data.past_days>=30">重新测试</a>
      <a v-else style="background-color:#ccc">{{30-data.past_days}} 天后可重测</a>
    </div>
    <div class="pro_main">
      <div class="pro_maint">
        <h2>亲爱的{{data.nickname}}，您好！<br/>您很好地完成了{{data.headtitle}}的测试，测试结果如下：</h2>
        <h3>*您的{{data.headtitle}}<br/>下面列出了您对各项价值重视程度的排序，排位越靠前，表明您越重视该项价值。</h3>
      </div>
      <div class="pro_mainb clearfix">
        <div class="pro_mainl">
          <ul>
            <li v-for="(item,index) in list" v-if="index<3" class="text-ellipsis">
              <img :src="ct_img[index]" />{{item.division}}
            </li>
          </ul>
        </div>
        <div class="pro_mainr">
          <ul>
            <li v-for="(item,index) in list" class="text-ellipsis" v-if="index>=3" :style="{ backgroundColor: 'rgba(0,160,246,'+ (1-((index-3)*0.05)) +')'}">
              {{index+1}}.{{item.division}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="pro_bottom">
      <h2>职业价值观{{list.length}}个主题名词解释：</h2>
      <ul>
        <li v-for="(item,index) in list" :key="index" :class="index==list.length-1?'list_last':''">
          <h3>{{item.division}}</h3>
          <p>{{item.explaining}}</p>
        </li>
      </ul>
    </div>
    <div class="men_foots" v-if="state">
      <router-link :to="'professional_measurement?cid='+ this.$route.query.cid + '&state=1'">重新测评</router-link>
    </div>
  </div>
</template>
<script>
import {
  ceping63_report,
  ceping63_reset
} from "@/api/measurement";
import {
  shareCon
} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        data: {},
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: "",
          state: false,
          list: {},
          ct_img: [],
          pro_js: {}
        },
        ctime:''
      }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      pullData() {
        ceping63_report()
          .then((data) => {
            if(data.code == 10002){
                this.$router.push({
                  path:'/ceping63',
                  query:{
                    state:1
                  }
                });
            }else if (typeof data !== 'string') {
              this.body_show = true;
              document.title = data.headtitle;
              this.ctime = data.ctime;
              this.list = data.list;
              this.data = data;
              this.state = data.state;
              this.nickname = data.nickname;
              this.ct_img = ['https://themes-cdn.xjy.cn/statics/career/images/pro1.png', 'https://themes-cdn.xjy.cn/statics/career/images/pro2.png', 'https://themes-cdn.xjy.cn/statics/career/images/pro3.png'];
              this.pro_js = {'收入待遇':'注重工作所给予的较高的经济回报及福利待遇。希望与其他人相比，能获得更丰厚的物质回报。','工作环境':'注重工作环境的舒适性，希望有宜人的办公环境。','组织氛围':'注重组织氛围。希望所在组织规则制度的公平透明，没有过多的隐性规则，奖惩制度公平公正。','平衡生活':'注重工作与生活的平衡。希望工作之余有较多时间和精力休闲娱乐、照顾家庭，不会过多牺牲个人和家庭生活。','工作稳定':'注重工作的稳定性，希望在长期稳定的组织或职位上工作，不会轻易丢掉工作。','持续挑战':'注重工作的挑战性，希望发挥自身优势，实现有挑战性的目标，能够从工作中获取成就感。','成长发展':'注重工作中的成长机会和发展空间。希望工作中有较多学习机会（培养与培训等），所在职业发展前景广阔，所在企业或行业前景光明。','他人认可':'注重组织(上级和同事等)、家庭、社会对自身工作的认可。希望工作成绩能够得到同事认可，工作能够得到家人认同，工作具有较高的社会地位。','人际和谐':'注重工作能够提供融洽的人际关系。希望工作中有融治的同事关系和氛围，能够与同事建立深厚友谊等。','管理权力':'注重工作赋予的管理他人的权力。工作中可以计划和分配任务、管理下属，向他人发布指示，领导他人。','开拓创造':'注重工作中发明创造新鲜事物的机会。希望自己的工作能设计新产品，发展新观念，常能够构思新的解决方法，经常尝试新的构想等。','志趣满足':'注重工作与个人兴趣的匹配。希望自己从事的工作和事业是自己喜欢的，能够享受工作过程。','道德操守':'注重道德操守，希望从事的工作不能违背职业道德、自身道德和社会公德的要求。','多样变化':'注重尝试变化，体验多样性。希望自己的工作能经常变换任务性质、内容、场所等，避免过规律重复的上班族生活。','独立自主':'注重个人能充分以自己的步调或方法来安排工作。希望自己的工作能不受他人干涉与限制，在职责范围内有充分自由等。'};

              this.type_obj.evaluation_id = this.$route.query.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = this.$route.query.uid;
              this.type_obj.nickname = data.nickname;
              this.type_obj.path = this.$route.path;
              shareCon("measurement", this, this.type_obj);
            } else {
              location.href = data;
            }

          })

      },
      reset() {
        this.$dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          ceping63_reset()
            .then((data) => {
              this.$router.push("/ceping63")
            })
        }).catch(() => {
          // on cancel
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.body_show {
  padding-bottom: 60px
}

.body_shows {
  padding-bottom: changeRem(2.96)+px
}

.top {
  width: 100%;
  background: url(../../../assets/pro_top.png) no-repeat top center;
  background-size: cover;
  height: 414px;
  padding: 0 60px;
  padding-top: 44px;
  color: #fff;
  h1 {
    font-size: 50px;
    font-weight: bold;
  }
  h2 {
    font-size: 26px;
    margin-top: 10px;
  }
  h3 {
    font-size: 20px;
    margin-top: 10px;
  }
  a {
    display: block;
    margin-top: 20px;
    width: 240px;
    height: 55px;
    background: #0D2589;
    border-radius: 8px;
    font-size: 30px;
    color: #fff;
    line-height: 55px;
    text-align: center;
  }
}
.pro_main {
  background: #fff;
  margin: 0 changeRem(0.64)+px;
  padding: changeRem(0.64)+px;
  border-radius: changeRem(0.16)+px;
  margin-top: -80px;
  position: relative;
  .pro_maint {
    padding-bottom: changeRem(0.8)+px;
    border-bottom: 2px dashed #ccc;
    h2 {
      line-height: changeRem(0.96)+px;
      font-size: changeRem(0.64)+px;
      color: #333;
      text-align: justify;
      position: relative;
      font-weight: bold;
      .date{
        font-size: 22px;
        position: absolute;
        top: 0;
        right: 0;
        line-height: 1;
      }
    }
    h3 {
      background: #eee;
      padding: changeRem(0.4)+px;
      border-radius: changeRem(0.16)+px;
      line-height: changeRem(0.8)+px;
      font-size: changeRem(0.52)+px;
      color: #333;
      text-align: justify;
      margin-top: changeRem(0.6)+px;
    }
  }
  .pro_mainb {
    width: 100%;
    margin-top: changeRem(0.8)+px;
    .pro_mainl {
      width: changeRem(6)+px;
      float: left;
      li {
        margin-bottom: changeRem(0.72)+px;
        color: #00A0F6;
        font-size: 28px;
        line-height: changeRem(1.6)+px;
        text-align: left;
        font-weight: 600;
        img {
          width: changeRem(1.6)+px;
          height: changeRem(1.6)+px;
          float: left;
          margin-right: changeRem(0.4)+px;
        }
      }
    }
    .pro_mainr {
      width: changeRem(5.8)+px;
      float: left;
      border-left: changeRem(0.08)+px solid #00A0F6;
      padding-left: changeRem(0.54)+px;
      li {
        font-size: 28px;
        line-height: changeRem(1.6)+px;
        color: #fff;
        background-color: rgba(0, 160, 246, 1);
        text-align: center;
      }
    }
  }
}

.pro_bottom {
  background: #fff;
  margin: 0 changeRem(0.64)+px;
  padding: changeRem(0.64)+px;
  border-radius: changeRem(0.16)+px;
  margin-top: changeRem(0.8)+px;
  text-align: justify;
  h2 {
    font-size: changeRem(0.64)+px;
    color: #333;
    margin-bottom: changeRem(0.4)+px;
    line-height: changeRem(0.65)+px;
    font-weight: bold;
  }
  li {
    margin-top: changeRem(0.4)+px;
    padding-bottom: changeRem(0.36)+px;
    border-bottom: 2px dashed #ccc;
    h3 {
      color: #00A0F6;
      font-size: changeRem(.52)+px;
      font-weight: bold;
    }
    p {
      color: #333;
      font-size: changeRem(0.52)+px;
      line-height: changeRem(0.8)+px;
      margin-top: changeRem(0.2)+px;
    }
  }
  .list_last {
    border-bottom: none
  }
}

.men_foots {
  width: 100%;
  height: changeRem(1.96)+px;
  position: fixed;
  bottom: 0;
  left: 0;
  max-width: 750px;
  text-align: center;
  background: #F4992E;
  z-index: 2;
  line-height: changeRem(01.96)+px;
  font-size: changeRem(0.68)+px;
  color: #fff;
  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff
  }
}
</style>
